"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Overlay = _interopRequireDefault(require("../Overlay"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
require('./popup.scss');
function Popup(props) {
  return /*#__PURE__*/_react.default.createElement(_Overlay.default, {
    isOpen: props.isOpen,
    onBackgroundClick: function onBackgroundClick() {
      return props.setDisplayPopup(false);
    },
    onClicking: function onClicking(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "popup-container"
  }, props.message, /*#__PURE__*/_react.default.createElement("div", {
    className: "popup-btn-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "popup-btn close-btn",
    onClick: props.onClose
  }, props.closeText), props.confirmBtn && /*#__PURE__*/_react.default.createElement("div", {
    className: "popup-btn confirm-btn",
    onClick: props.onConfirm
  }, props.confirmText))));
}
var _default = exports.default = Popup;